import { fetchApi } from "containers/helpers";

export const getUsers = () => fetchApi('/users')

export const sendEmailValidationAPI = (email) => fetchApi('/user/sendConfirmationEmail/'+email)